import request from 'superagent';
import shiroTrie from 'shiro-trie';

import * as UserUtils from 'utils/user';
import * as CustomerUtils from 'utils/customer';
import * as types from 'constants/ActionTypes';
import {
  ADMIN_LOGOUT_URL,
  USER_INFO_URL,
  SESSION_KEEPALIVE_URL,
  CUSTOMERS_URL,
} from 'constants/Jaws';

function logoutUser() {
  return { type: types.LOGOUT_USER };
}

function requestUserInfo() {
  return { type: types.REQUEST_USER_INFO };
}

function receiveUserInfo(data) {
  return { type: types.RECEIVE_USER_INFO, data };
}

export function setActiveAccount(customerId) {
  const data = { customerId };

  return dispatch => {
    dispatch({ type: types.USER_SET_SELECTED_ACCOUNT, data });

    if (window.localStorage) {
      localStorage.setItem('lastActiveAccount', customerId);
    }

    // Refresh balance on user
    dispatch(fetchMarginInfo());
    dispatch(fetchBalance());
  };
}

export function logout(callback) {
  return dispatch => {
    return request.post(`${ADMIN_LOGOUT_URL}`).end(err => {
      if (err) throw new Error(err);

      dispatch(logoutUser());
      if (callback) callback();
    });
  };
}

export function keepaliveSession() {
  return request.get(SESSION_KEEPALIVE_URL).end(err => {
    if (
      err &&
      err.status === 401 &&
      window.location.pathname !== '/logged-out' &&
      window.location.pathname !== '/not-customer' &&
      window.location.pathname !== '/admin/login' &&
      window.location.pathname !== '/admin/change-password' &&
      window.location.pathname !== '/admin'
    ) {
      window.location.pathname = '/logged-out';
    }
  });
}

export function fetchUserInfo(callback) {
  return (dispatch, getState) => {
    dispatch(requestUserInfo());

    return request
      .get(`${USER_INFO_URL}`)
      .then(res => {
        const [data] = res.body.data['principals'];
        data.shiro = shiroTrie.new().add(data.permissions);

        dispatch(receiveUserInfo(data));

        const customer = UserUtils.getCustomerData(getState().user);
        if (customer) {
          const selectedAccount = CustomerUtils.getSelectedAccount(customer);
          const customerId = selectedAccount.get('customerId');
          dispatch(setActiveAccount(customerId));
        }

        dispatch(fetchMarginInfo());
        dispatch(fetchBalance());
        if (callback) callback(data);
      })
      .catch(err => {
        dispatch(logoutUser());
        throw new Error(err);
      });
  };
}

export function fetchBalance() {
  return (dispatch, getState) => {
    const customer = UserUtils.getCustomerData(getState().user);

    if (!customer) return;

    const selectedAccount = CustomerUtils.getSelectedAccount(customer);
    const userId = selectedAccount.get('customerNumber');
    const customerId = selectedAccount.get('customerId');
    return request
      .get(`${CUSTOMERS_URL}/${userId}/balance/${customerId}`)
      .then(res => {
        dispatch({
          type: types.USER_INFO_SET_BALANCE,
          balance: res.body.data.balance,
        });
      })
      .catch(() => {});
  };
}

export function fetchMarginInfo() {
  return (dispatch, getState) => {
    const customer = UserUtils.getCustomerData(getState().user);

    if (!customer) return;

    const selectedAccount = CustomerUtils.getSelectedAccount(customer);
    const customerId = selectedAccount.get('customerId');
    const customerNumber = selectedAccount.get('customerNumber');

    if (!selectedAccount.get('marginAccount')) return;

    return request
      .get(`${CUSTOMERS_URL}/${customerNumber}/margin-info/${customerId}`)
      .end((err, res) => {
        dispatch({
          type: types.USER_INFO_SET_MARGIN,
          marginInfo: res.body.data,
        });
      });
  };
}
